"use client"

import { motion } from "framer-motion"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

const faqs = [
    {
    question: "Is acupuncture painful?",
    answer: "Not at all. You may feel a mild sensation—tingling, dullness, or warmth—but most people find it deeply relaxing, and often fall asleep during treatment."
    },
    {
    question: "What happens in a session?",
    answer: "Before you arrive, you'll complete a short intake form. This means more time on the table and less time talking. Renee will go over your main concerns and check your pulse, tongue, and abdomen. Then you'll receive a tailored treatment, which may include acupuncture, moxibustion, cupping, or gua sha. Most sessions include 25–30 minutes of quiet rest with the needles in."
    },
    {
    question: "What should I wear?",
    answer: "Loose, comfortable clothing is best—but don't worry, towels and draping are always provided if needed."
    },
  {
    question: "Do you offer HICAPS claiming?",
    answer: "Yes. We have HICAPS facilities so you can claim your private health fund rebate on the spot, saving you the time and effort of lodging a manual claim later."
  },
  {
    question: "Am I eligible for a health fund rebate?",
    answer: "Rebate eligibility depends on your individual health fund and level of cover. We recommend checking with your health fund to confirm your benefits before your appointment."
  },
  {
    question: "What do I need to bring to lodge a health fund claim on the day?",
    answer: "Please bring your private health fund membership card. We'll process your rebate immediately after your consultation, and you just pay the remaining gap."
  }
]

export function FAQFees() {
  return (
    <section id="faq-fees-section" className="py-20 bg-white mt-0 lg:mt-20 lg:mb-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl mb-4 text-[#3f4141]">FAQ</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Frequently Asked Questions about appointments, fees and rebates.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible>
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-[#3f4141] text-xl font-light text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          {/* FAQPage Structured Data */}
          <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((f) => ({
                '@type': 'Question',
                name: f.question,
                acceptedAnswer: { '@type': 'Answer', text: f.answer },
              })),
            }),
          }} />
        </motion.div>
      </div>
    </section>
  )
}

